<template lang="pug">
	.step
		.step__title
			|Рассчитайте и оформите полис онлайн
		.step__list
			.step__item.step__item_sports
				.step__item-left
					.step__pic
						img.step__pic-elem(src="img/sports.svg")
				.step__item-right
					app-input(:input="schema.sports", :disabled="true", :field.sync="selectedSportsNames" @togglePopup="togglePopup")
					.input-desc
						.input-desc__title
							|Например:
						.input-desc__list
							.input-desc__item(v-for="sport in getInputDescription")
								a.input-desc__link(href="#", @click.prevent="selectSport(sport)")
									|{{sport.UF_NAME}}
			.step__item
				.step__item-left
					.step__pic
						img.step__pic-elem(src="img/monthly_calendar.svg")
				.step__item-right
					App-slider-input(:input="schema.term", :options="termOptions")
			.step__item
				.step__item-left
					.step__pic
						img.step__pic-elem(src="img/count.svg")
				.step__item-right
					App-slider-input(:input="schema.count", :options="countOptions")
			.step__item
				.step__item-left
					.step__pic
						img.step__pic-elem(src="img/sum.svg")
				.step__item-right
					App-slider-input(:input="schema.sum", :options="sumOptions")
		.step__button
			a.button(href="#", ref="buttonNext", @click.prevent="handleClick")
				|Далее
			
		.popup-overlay(@click="togglePopup", v-if="popupIsActive")
			.popup(@click.stop)
				.popup__inner
					.popup__close(@click="togglePopup")
					.popup__title
						|Выберите из списка (не более 5-ти):
					.popup__list
						.popup__item(v-for="(sport, index) in sportList", :class="selectedSports.indexOf(sport) != -1 ? 'active' : ''", :key="sport.ID")
							.popup__inner-item
								a.popup__link(href="#", @click.prevent="selectSport(sport)")
									|{{sport.UF_NAME}}
								.popup__remove(@click="removeSport(sport)")
					.popup__button
						a.popup__button-elem(href="#", @click.prevent="togglePopup")
							|Ок

</template>

<script>
// @ is an alias to /src
import AppInput from '@/components/Input.vue'
import AppInputDropdown from '@/components/Input-dropdown.vue'
import AppSliderInput from '@/components/Slider-input.vue'
import VueSlider from 'vue-slider-component'
import 'vue-slider-component/theme/antd.css'
import { mapFields } from 'vuex-map-fields';
import { mapGetters } from 'vuex';
export default {

  name: 'app-step1',
  components: {
    AppInput,
    AppInputDropdown,
    VueSlider,
    AppSliderInput
  },
  created(){
  	this.$store.dispatch('getData');
  	
  },
  mounted(){
  	console.log(this.$route)
  },
  data() {
  	return {
  		
  	}
  },
  methods:{
  	handleClick(){
  		this.$validator.validate().then(valid => {
        if (valid && this.selectedSports.length) {
           this.$router.push({name: 'step2'})
           this.$store.dispatch('setInsuredPeopleCount')
        }
      });
  	},
  	togglePopup(){
  		this.$store.commit('setPopupIsActive', !this.popupIsActive)
  		// this.popupIsActive = !this.popupIsActive;
  	},
  	selectSport(item) {
  		if(this.selectedSports.indexOf(item) == -1 && this.selectedSports.length < 5) {
  			this.selectedSports.push(item)
  		}
  		if(this.selectedSports.length >= 5) {
  			this.$store.commit('setPopupIsActive', !this.popupIsActive)
  		}
  	},
  	removeSport(item){
  		this.selectedSports.splice(this.selectedSports.indexOf(item), 1)
  	}
  },
  computed:{
  	getInputDescription(){
  		return this.sportList.slice(0,2);
  	},
  	selectedSportsNames(){
  		if(this.selectedSports.length) {
  			return this.selectedSports.map(item => ' ' + item.UF_NAME)
  		}
  	},
  	...mapFields([
      'termOptions',
      'countOptions',
      'sumOptions',
      // 'popupIsActive'
      'selectedSports',
      'totalCost'
    ]),
    ...mapGetters({
		  schema: 'getSchema',
		  popupIsActive: 'getPopupIsActive',
		  sportList: 'getSportList',
		  sportTariffs: 'getSportTariffs',
		})
  }
}
</script>

<style lang="scss">
.suggestions-wrapper {
	position: relative;
	z-index: 10;
	
}
.suggestions-suggestions {
	background-color: #fff;
	cursor:pointer;
}
.input-desc {
	display: flex;
	align-items:center;
	margin-top: -2px;
	padding-left: 3px;
  
	&__title{
		font-size: 12px;
	  color: #808080;
		margin-right: 5px;
	}
	&__list {
		display: flex;
	}
	&__item{
		margin-right: 5px;
		&:last-child {
			margin-right: 0;
		}
		
	}
	&__link{
		color:#04a4b0;
		font-size: 12px;
		text-decoration: none;
	}
}
	.popup {
		background-color: #fff;
		// max-width: 50vw;
		// max-height: 50vh;
		
		
		border-radius:3px;
		position: relative;
		&-overlay {
			display: flex;
			align-items:center;
			justify-content:center;
			z-index: 100;
			position: fixed;
			top: 0;
			left: 0;
			background-color: rgba(#000, .3);
			height: 100%;
			width: 100%;
		}
		&__inner {
			max-width: 50vw;
	    max-height: 50vh;
	    overflow-y:scroll;
	    padding: 20px 37px 20px 20px;
		}
		&__title {
			margin-bottom: 20px;
			color:#101b50;
			font-size: 24px;
		}
		&__list {
			// font-size: 0;
			padding-right: 50px;
			// white-space: nowrap;
		}
		&__button {
			position: absolute;
			right:20px;
			bottom: 20px;
			&-elem {
				background-color: #1DB4C3;
		    color: #fff;
		    padding: 12px 28px 13px;
		    border-radius: 4px;
		    max-width: 200px;
		    width: 100%;
		    display: flex;
		    align-items: center;
		    justify-content: center;
		    border: 1px solid #04a4b0;
		    transition: .3s linear;
		    text-decoration: none;
		    font-size: 18px;
		    font-weight: 300;
		    outline: none;
		    cursor: pointer;
			}
		}
		&__close {
			position: absolute;
			right: 20px;
			top: 20px;
			height: 20px;
			width:20px;
			cursor: pointer;
			transition:.2s;
			&:hover {
				transform:rotate(90deg);
			}
			&:before {
				content:'';
				display: block;
				background-color: $primary;
				height: 3px;
				width: 20px;
				position: absolute;
				right: 0px;
				top: 9px;
				transform:rotate(45deg);
			}
			&:after {
				content:'';
				display: block;
				background-color: $primary;
				height: 3px;
				width: 20px;
				position: absolute;
				right: 0px;
				top: 9px;
				transform:rotate(-45deg);
			}
		}
		&__remove {
			// position: absolute;
			height: 20px;
			width: 20px;
			display: none;
			right: -30px;
			cursor: pointer;
			// top: 2px;
			@include centered(y);
			&:before {
				content:'';
				display: block;
				background-color: $primary;
				height: 2px;
				width: 15px;
				position: absolute;
				right: 2px;
				top: 9px;
				transform:rotate(45deg);
			}
			&:after {
				content:'';
				display: block;
				background-color: $primary;
				height: 2px;
				width: 15px;
				position: absolute;
				right: 2px;
				top: 9px;
				transform:rotate(-45deg);
			}
		}
		&__item {
			margin-bottom: 10px;
			&:last-child {
				margin-bottom: 0;
			}
			&.active {
				.popup__link {
					background-color: $primary;
					color:#fff;
				}
				.popup__remove {
					display: block;
				}
			}
		}
		&__inner-item {
			position: relative;
			display: inline-block;
		}
		&__link {
			text-decoration: none;
			color:$primary;
			padding:3px 5px;
			border-radius: 9px;
			position: relative;
			display: inline-block;
			transition:.2s;

		}
	}
	.step {
		&__desc {
	    width: 70%;
	    margin-top: 35px;
	    color: #808080;
	    font-size: 12px;
		}
		&__title {
			color:#101b50;
			font-size: 30px;
			margin-bottom: 42px;
			display: flex;
		}
		&__list {
			display: flex;
			flex-wrap:wrap;
			margin-left: -20px;
		}
		&__item {
			margin-left: 20px;
			width:calc(50% - 21px);
			display: flex;
			margin-bottom: 42px;
			// align-items:center;
			&_large {
				width:calc(70% - 21px);
			}
			&_small {
				width: calc(30% - 20px);
			}
			&_sports {

			}
			&-left {
				width: 42px;
				flex-shrink:0;
			}
			&-right {
				// width: calc(100% - 42px);
				flex:1;
				position: relative;
			}
		}
		&__pic {
			max-width: 100%;
			&-elem {
				display: block;
				margin:0 auto;
			}
		}
		&__button {
			display: flex;
			justify-content:flex-end;
		}
	}
	.button {
		background-color: #1DB4C3;
		color:#fff;
		padding: 12px 28px 13px;
    border-radius: 4px;
		max-width: 200px;
		width: 100%;
		display: flex;
		align-items:center;
		justify-content:center;
		border:1px solid #04a4b0;
		transition:.3s linear;
		text-decoration: none;
		font-size: 22px;
		font-weight: 300;
		outline:none;
		cursor:pointer;
		&_type-simple {
			color: #1db4c0;
	    background-color: transparent;
	    border:none;
	    &:hover {
  	    color: #20c5d2;
		    background-color: transparent !important;
	    }
		}
		&.disabled {
			opacity: .5;
			&:hover {
				// background-color:$primary;
				// color:#fff;
			}
		}
		&_width_full {
			max-width: unset;
		}
		&:hover:not(.disabled) {
			// background-color: transparent;
			// color:#04a4b0;
	    background-color: #1aa3ae;
		}
	}
</style>